






















import Vue from 'vue';
import ProvinceUtils, { Province } from '@/utils/ProvinceUtils';
import { locales } from '@/i18n';

export default Vue.extend({
  computed: {
    table() {
      return {
        items: this.items,
        headers: [
          {
            text: this.$i18n.tc('province.key'),
            value: 'key',
          },
          {
            text: this.$i18n.tc('province.name'),
            value: 'name',
          },
          {
            text: '',
            value: 'actions',
          },
        ],
      };
    },

    locales() {
      return locales;
    },
  },

  data: (): {
    items?: Province[];
  } => ({
    items: undefined,
  }),

  async mounted() {
    try {
      this.items = await ProvinceUtils.province.api.list();
    } catch (error) {
      console.error(error);
    } finally {
      //
    }
  },

  methods: {
    async handleEdit(item: Province) {
      await this.$router.push({
        name: 'province-edit',
        params: { id: item.id.toString() },
      });
    },

    async handleCreate() {
      await this.$router.push({
        name: 'province-create',
      });
    },
  },
});
